import React from 'react';
import PropTypes from "prop-types";

export default function MobileTransferSVG(props) {
  return (
    <svg 
      width={props.styles.width} 
      height={props.styles.height}
      fill={props.styles.fill}
      id={props.id || ''}
      className={props.className || ''}
      version="1.1"
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink">
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Icon/Ticket-Type/Mobile-Transfer" fill={props.styles.fill}>
          <path d="M25.5,11 L25.5,29 C25.5,30.6568542 24.1568542,32 22.5,32 L9.5,32 C7.84314575,32 6.5,30.6568542 6.5,29 L6.5,21 L9,21 L9,28.5 C9,29.0128358 9.38604019,29.4355072 9.88337887,29.4932723 L10,29.5 L22,29.5 C22.5128358,29.5 22.9355072,29.1139598 22.9932723,28.6166211 L23,28.5 L23,11 L25.5,11 Z M16,25.5 C16.8284271,25.5 17.5,26.1715729 17.5,27 C17.5,27.8284271 16.8284271,28.5 16,28.5 C15.1715729,28.5 14.5,27.8284271 14.5,27 C14.5,26.1715729 15.1715729,25.5 16,25.5 Z M3.72792196,15.1 L4.65990245,16.1125 L2.522,18.335 L12,18.3340545 L12,19.7659457 L2.522,19.766 L4.65990245,22.0875 L3.72792196,23.1 L0.93198049,20.0625 L1.46199946e-15,19.0500001 L0.93198049,18.0375001 L3.72792196,15.1 Z M22.5,0 C24.1568542,-3.04359188e-16 25.5,1.34314575 25.5,3 L25.5,7 L23,7 L23,3.5 C23,2.94771525 22.5522847,2.5 22,2.5 L10,2.5 C9.48716416,2.5 9.06449284,2.88604019 9.00672773,3.38337887 L9,3.5 L9,17 L6.5,17 L6.5,3 C6.5,1.34314575 7.84314575,3.04359188e-16 9.5,0 L22.5,0 Z M28.272078,4.9 L31.0680195,7.9375 L32,8.9499999 L31.0680195,9.9624999 L28.272078,12.9 L27.3400976,11.8875 L29.478,9.665 L20,9.6659455 L20,8.2340543 L29.478,8.234 L27.3400976,5.9125 L28.272078,4.9 Z" id="Combined-Shape"/>
        </g>
      </g>
    </svg>
  );
}

MobileTransferSVG.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  styles: PropTypes.shape({
    fill: PropTypes.string,
    height: PropTypes.string,
    width: PropTypes.string
  })
};
